import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateVariable from "./CreateVariable";
import UserService from "services/UserService";
import axios from "axios";
import { getBackOfficeRealestate } from "services/ConfigServices";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { markets } from "variables/markets";
import { statusData, energyData } from "variables/lists/markets";
import moment from "moment";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function usePatrimoineTable() {
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getBackOfficeRealestate();
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {

      if (prevRefresh && prevRefresh === refresh) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      fetchData();
    
  }, [refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `variables`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedMarkets.map((item) => {
      let markettoexport = {};
      markettoexport[markets.general.name] = item.parameters.name;
      markettoexport[markets.general.status] = statusData.find((x) => x.id == item.parameters.status)?.name;
      markettoexport[markets.general.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      markettoexport[markets.general.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      markettoexport[markets.general.energy] = energyData.find((x) => x.id == item.parameters.energy)?.name;
      markettoexport[markets.membershipcount] = item.membershipcount;
      
      return markettoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />

        <UploadButton type="button" onClick={handleClear}>
          <CreateVariable refetch={refreshTable} onClick={handleClear} />
        </UploadButton>

        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedMarkets || selectedMarkets.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedMarkets]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refreshTable,
    setSelectedMarkets
  };
}
